import { useTranslation } from 'react-i18next'

import { EntityTabSubTabs } from '../../../EntityTab'
import {
  getIsRequestProfileTabChatsSubTabsVisible,
  getRequestProfileTabChatsSubTabQaName,
  getRequestProfileTabChatsToggleItems,
} from '../RequestProfileTabChats.utils'

import { renderRequestProfileTabChatsSubTabItem } from './RequestProfileTabChatsSubTabs.utils'

import * as styles from './RequestProfileTabChatsSubTabs.module.css'

function RequestProfileTabChatsSubTabs({
  activeSubTab,
  allowedSubTabs,
  counters,
  onSetActiveSubTab,
}) {
  const { t } = useTranslation()

  const items = getRequestProfileTabChatsToggleItems({
    allowedSubTabs,
    counters,
    t,
  })

  return getIsRequestProfileTabChatsSubTabsVisible(items) ? (
    <EntityTabSubTabs
      activeValue={activeSubTab}
      className={styles.subTabs}
      getItemQaName={getRequestProfileTabChatsSubTabQaName}
      items={items}
      renderItem={renderRequestProfileTabChatsSubTabItem}
      onChange={onSetActiveSubTab}
    />
  ) : null
}

export default RequestProfileTabChatsSubTabs
